import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from "react";
import styled from "styled-components";
import motionIcon from "../../assets/icons/motions.png";
var StyledTitle = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  img {\n    width: 16px;\n    height: 16px;\n  }\n  span {\n    font-family: MicrosoftYaHei;\n    font-size: 12px;\n    color: #b1b1b1;\n    line-height: 20px;\n  }\n"])));
export default function MotionTitle(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(StyledTitle, null, /*#__PURE__*/React.createElement("img", {
    src: motionIcon,
    alt: "motion"
  }), /*#__PURE__*/React.createElement("span", null, text));
}